<template>
	<el-dialog
			    title="话术卡片"
			    :visible.sync="dialogVisibe"
			    width="660px"
			    :custom-class="classNames + '_dialog'"
			    key="replyDialog"
				:close-on-press-escape="false"
				:close-on-click-modal="false"
			    @close="cardBtnCancel">
			        <div class="card-control-form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="150px">
							
							<el-form-item label="选择分组:" prop="group_id">
							    <el-select v-model="ruleForm.group_id">
							        <el-option label="全部分组" :value="0" :key="-1"></el-option>
							        <el-option v-for="(item, index) in groupListData" :label="item.name"
							            :value="item.id" :key="index"></el-option>
							    </el-select>
							</el-form-item>
							
							<el-form-item label="标题:" prop="title">
							    <el-input v-model="ruleForm.title" placeholder="请输入标题" maxlength="20" show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="话术类型:" prop="type">
							    <el-radio-group v-model="ruleForm.type">
							        <el-radio  v-for="item in typeList" :label="item.value" :key="item.value">{{item.label}}</el-radio>
							    </el-radio-group>
							</el-form-item>
							<el-form-item label="话术内容:" prop="content" v-if="ruleForm.type == 1">
							    <el-input  type="textarea" :rows="4" v-model="ruleForm.content" placeholder="请输入话术内容" maxlength="100" show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="话术内容:" prop="content" v-if="ruleForm.type == 2">
							   <div :class="classNames+ '_reply-card'">
								  <el-form-item label="链接描述:" prop="content">
									   <el-input  type="textarea" :rows="4" v-model="ruleForm.content" placeholder="请输入链接描述" maxlength="100" show-word-limit></el-input>
								  </el-form-item> 
								  <el-form-item label="链接标题:" prop="link_title">
								  									   <el-input  v-model="ruleForm.link_title" placeholder="请输入链接标题" maxlength="20" show-word-limit></el-input>
								  </el-form-item> 
								  <el-form-item label="跳转链接:" prop="link_url">
								  									   <el-input   v-model="ruleForm.link_url" placeholder="请输入http或http开头的正确链接" maxlength="100"></el-input>
								  </el-form-item> 
								   
								   
									
							   </div>
							</el-form-item>
						 </el-form>
					</div>
			        <span slot="footer" class="dialog-footer">
			            <el-button @click="cardBtnCancel()">取 消</el-button>
			            <el-button type="primary" @click="cardBtnSure()">确 定</el-button>
			        </span>
			</el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
		replyFormInfo: {
		    type: Object,
			default: () => ({
				id: '',
			    group_id: 0,
				title: '',
				type: 1,
				content: '',
				link_title: '',
				link_url: ''
			})
		},
		groupListData: {
		    type: Array,
		    default: () => ([])
		},
	},
	data() {
		return {
			showFlag: true,
            classNames: "replyDialog",
			rules: {
			    group_id: [
			        { required: true, message: '请选择分组', trigger: 'change' }
			    ],
				title: [
			        { required: true, message: '请输入标题', trigger: 'blur' },
			    ],
				type: [
				    { required: true, message: '请选择话术类型', trigger: 'change' }
				],
				content: [
				    { required: true, message: '请输入话术内容', trigger: 'blur' },
				],
				link_desc: [
				    { required: true, message: '请输入链接描述', trigger: 'blur' },
				],
				link_title: [
				    { required: true, message: '请输入链接标题', trigger: 'blur' },
				],
				link_url:{
						required: true,
						validator: (rule, value, callback) => {
							if(value.length > 0) {
								const ishttp = value.indexOf('http')
								if(ishttp != 0){
									callback(new Error('请输入http或http开头的正确链接'))
								}
							} else {
								callback(new Error('请输入跳转链接'))
							}
							callback()
						},
						trigger: 'blur'
					}
			},
			typeList: [
			    {
			        label: '文字',
			        value: 1
			    },
			    // {
			    //     label: '链接',
			    //     value: 2
			    // }
			]
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		},
		ruleForm: {
			get() {
				return this.replyFormInfo
			},
			set(news) {
				// this.ruleForm = news
			}
		},
	},
	methods: {
		...mapActions('dymessage', ['replyAddoredit']),
		cardBtnSure(){
			this.$refs.ruleForm.validate(async (valid) => {
				if(valid) {
					try {
						const paramsData = {
							id: this.ruleForm.id,            
							group_id:  this.ruleForm.group_id,
							title: this.ruleForm.title,
							type: this.ruleForm.type,
							content: this.ruleForm.content,
							link_title: this.ruleForm.link_title,
							link_url: this.ruleForm.link_url,
						}
						await this.replyAddoredit(paramsData)
						this.$emit('replyList')
						this.resetFormInfo()
					} catch (error) {
						this.$message({
						    type: 'error',
						    message:'操作失败',
						    duration: 3000
						})
					}
				}
			})
		},
		cardBtnCancel(){
			this.dialogVisibe = false
		},
		resetFormInfo(){
			this.dialogVisibe = false
		}
	}
}
</script>
<style lang="less">
    .replyDialog_dialog {
        .el-dialog__body {
            padding: 12px 20px;
        }
		.el-dialog__footer{
			text-align: center;
		}
    }
</style>
<style lang="less">
    @classNames: replyDialog;
    	 .@{classNames}_reply-card{
			 background-color: #f2f2f2;
			 padding: 20px 40px;
			border-radius: 4px;
			 .el-form-item{
				margin-bottom: 20px;
				 margin-left: -40px;
			 }
    	 }
</style>

 